import {
  isPublicProfileSummaryPath,
  isPublicProfileRecordsPath,
  isPublicProfileBadgesPath,
  isMyProfileScrollPath,
  isSettingsScrollPath,
} from '../features/profile/routes';
import { useUserStore } from '../stores/userStore';
import { isSearchScrollRoute } from '../features/search/searchViewMemory';
import { useNavigate, useLocation, useNavigationType } from 'react-router-dom';
import { useEffect, useRef } from 'react';

// These landing/full lists own URL/account-scoped restoration after their data is ready.
const ownsBrowseScroll = (path) =>
  /^\/(albums|reviews|lists|explore)\/?$/.test(path) ||
  /^\/artists\/[^/]+/.test(path) ||
  // Playlist detail now restores after its comments and body have loaded.
  /^\/lists\/(?!(?:new|create)(?:\/|$))[^/]+(?:\/comment\/\d+)?\/?$/.test(path);

export const useNavigateWithScrollMemory = () => {
  const navigate = useNavigate();
  const admin = useUserStore((s) => s.isAdmin);
  const viewer = useUserStore((s) => s.user?.id);
  const login = useUserStore((s) => s.isLogin);
  const location = useLocation();
  const ownsProfileScroll =
    isSettingsScrollPath(location.pathname) ||
    (viewer != null && login && isMyProfileScrollPath(location.pathname)) ||
    (!admin &&
      (isPublicProfileSummaryPath(location.pathname) ||
        isPublicProfileRecordsPath(location.pathname) ||
        isPublicProfileBadgesPath(location.pathname)));
  const navigationType = useNavigationType();
  const isBackNavigation = useRef(false);

  const navigateWithScrollMemory = (to, options) => {
    // 현재 위치와 스크롤 Y 값을 저장
    if (
      !isSearchScrollRoute(location.pathname) &&
      !ownsBrowseScroll(location.pathname) &&
      !ownsProfileScroll
    )
      sessionStorage.setItem(`scroll-position:${location.pathname}`, window.scrollY);
    navigate(to, options);
  };

  useEffect(() => {
    // navigationType이 'POP'이면 뒤로가기/앞으로가기
    if (navigationType === 'POP') {
      isBackNavigation.current = true;
    }
  }, [navigationType]);

  useEffect(() => {
    let restoreTimer;
    // 뒤로가기로 인한 네비게이션인 경우에만 스크롤 위치 복원
    if (
      isSearchScrollRoute(location.pathname) ||
      ownsBrowseScroll(location.pathname) ||
      ownsProfileScroll
    ) {
      isBackNavigation.current = false;
      return;
    }
    if (isBackNavigation.current) {
      const savedY = sessionStorage.getItem(`scroll-position:${location.pathname}`);
      if (savedY !== null) {
        // DOM이 완전히 렌더링된 후 스크롤 복원
        restoreTimer = setTimeout(() => {
          window.scrollTo({
            top: parseInt(savedY, 10),
            behavior: 'auto',
          });
          sessionStorage.removeItem(`scroll-position:${location.pathname}`);
        }, 100);
      }
      // 뒤로가기 플래그 리셋
      isBackNavigation.current = false;
    }
    return () => clearTimeout(restoreTimer);
  }, [location.pathname, ownsProfileScroll]);

  return navigateWithScrollMemory;
};
